export var FilterMenuType;
(function (FilterMenuType) {
    FilterMenuType["FILTER"] = "filter";
    FilterMenuType["BRAND"] = "brand";
    FilterMenuType["CONDITION"] = "condition";
    FilterMenuType["PRICE"] = "price";
    FilterMenuType["YEAR"] = "year";
    FilterMenuType["SIZE"] = "size";
    FilterMenuType["OTHER"] = "other";
})(FilterMenuType || (FilterMenuType = {}));
